import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";

const ReactQuillData2 = ({ data, setData, level, key }) => {
  const [value, setValue] = useState(data || "");
  const hasEditedRef = useRef(false);
  useEffect(() => {
    if (data && !hasEditedRef.current) {
      setValue(data);
    }
  }, [data]);
  useEffect(() => {
    setData(value);
  }, [value]);

  // Define the toolbar and other modules for ReactQuill
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [
        {
          color: [
            "red",
            "blue",
            "yellow",
            "#E5BF83",
            "gray",
            "#dc3545",
            "#2A3989",
          ],
        },
      ],
      ["link", "image", "video"],
      ["clean"],
      [{ direction: "rtl" }],
    ],
    clipboard: {
      matchVisual: true,
    },
  };

  return (
    <div>
      <ReactQuill
        key={key}
        modules={modules}
        theme="snow"
        style={{ height: "150px" }}
        value={value} // Controlled value
        onChange={(html) => {
          hasEditedRef.current = true;
          setValue(html);
        }} // Update value when content changes
      />
    </div>
  );
};

export default ReactQuillData2;
